import React from 'react';
import PropTypes from 'prop-types';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@tempmee/react';

const COLUMNS = [
  'Campaign Name',
  'Campaign Type',
  'Eligible Since',
  'Campaign Status',
  'Pro Status',
];

/**
 * The Campaigns tab's table. Purely presentational — rows arrive already
 * mapped and already ordered (matched_at DESC, server-side), so nothing here
 * sorts or reformats.
 */
export const CampaignsTable = ({ campaigns }) => (
  <TableContainer>
    <Table size="medium">
      <TableHead>
        <TableRow>
          {COLUMNS.map((column) => (
            <TableCell key={column}>{column}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {campaigns.map((campaign) => (
          <TableRow key={campaign.campaignId} hover>
            <TableCell>{campaign.campaignName}</TableCell>
            <TableCell>{campaign.triggerTypeLabel}</TableCell>
            <TableCell>{campaign.matchedAtLabel}</TableCell>
            <TableCell>{campaign.statusLabel}</TableCell>
            <TableCell>{campaign.proStatusLabel}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

CampaignsTable.propTypes = {
  /** Mapped eligibility rows, in the order the endpoint returned them. */
  campaigns: PropTypes.arrayOf(
    PropTypes.shape({
      campaignId: PropTypes.string,
      campaignName: PropTypes.string,
      triggerTypeLabel: PropTypes.string,
      matchedAtLabel: PropTypes.string,
      statusLabel: PropTypes.string,
      proStatusLabel: PropTypes.string,
    }),
  ).isRequired,
};
